import { useSelector } from 'react-redux'

export const useIsAdmin = () => {
    // @ts-expect-error redux store is not typed properly
    return useSelector((state) => (state?.userRecord && state.userRecord.isAdmin) ?? false)
}
